const NPSQuestionnaireSecondStep = ({ handleSecondStepClick, selectedReasons, setSelectedReasons, handleBackBtn }) => {
    const reasonOptions = [
        "Logistics pickup and support",
        "Timely supply of material",
        "Test turnaround time (TAT)",
        "Frequency of sales representative meetings",
        "Knowledge and communication of Customer care advisors",
        "Query / Complaint resolution quality",
        "Received bill / Invoices on time"
    ]

    const handleReasonChange = (reason) => {
        setSelectedReasons((prev) => {
            const updatedReasons = prev.includes(reason)
                ? prev.filter(item => item !== reason)
                : [...prev, reason];

            //console.log("Selected reasons:", updatedReasons);
            return updatedReasons;
        });
    };

    return (
        <>
            <div className="content-wrapper">
                <div className="middle-content-wrapper">
                    <div className="text-content">
                        <p className="text-center">We regret you did have a delightful experience. Please select a reason for your ratings.</p>

                        <div className="middle-content-wrapper">

                            <div className="reason-form">
                                <div className="reason-options">
                                    {reasonOptions.map((reason, index) => (
                                        <label key={index} className="reason-option w-100">
                                            <input
                                                type="checkbox"
                                                checked={selectedReasons.includes(reason)}
                                                onChange={() => handleReasonChange(reason)}
                                            />
                                            <span className="checkmark"></span>
                                            <span className="reason-text">{reason}</span>
                                        </label>
                                    ))}
                                </div>

                                <div className="button-group">
                                    <button
                                    className="back-button"
                                        onClick={handleBackBtn}
                                    >
                                        Back
                                    </button>

                                    <button
                                        className={`${selectedReasons.length === 0 ? "next-button-disabled" : "next-button"}`}
                                        onClick={handleSecondStepClick}
                                        disabled={selectedReasons.length === 0}
                                    >
                                        Next
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default NPSQuestionnaireSecondStep